import angular from 'angular';
import { find } from 'lodash';

const EXPERIMENT = 'EXPERIMENT';
const FOUNDATION = 'FOUNDATION';
const INITIAL = 'INITIAL';
const MIS_SCOPE = 'MIS_SCOPE';
const OTHER = 'OTHER';
const OVER_CAPACITY = 'OVER_CAPACITY';
const PERMIT = 'PERMIT';
const MATERIAL_SOURCING = 'MATERIAL_SOURCING';
const REWORK = 'REWORK';
const TARGET_CHANGE = 'TARGET_CHANGE';
const UTILITY = 'UTILITY';
const VENDOR_DELAYS = 'VENDOR_DELAYS';
const WEATHER = 'WEATHER';

class Reason {
  constructor(reason, description) {
    this.reason = reason;
    this.description = description;
  }
}

module.exports = angular.module('common.values.work-order-time-estimate-types', [])
.factory('VENDOR_TIME_ESTIMATE_REASONS', function() {
  return [
    new Reason(
      MIS_SCOPE,
      'The original scope was incorrect, so the reno manager had to add time for the revised scope.'
    ),
    new Reason(
      OVER_CAPACITY,
      'The work will be late because resources are stretched too thin.'
    ),
    new Reason(
      PERMIT,
      'City permit delay for trade work.'
    ),
    new Reason(
      MATERIAL_SOURCING,
      'Sourcing of raw materials has caused delays.'
    ),
    new Reason(
      REWORK,
      "Work didn't pass QA and must be fixed"
    ),
    new Reason(
      TARGET_CHANGE,
      'The work order target dates have changed so updating the estimate with that in mind.'
    ),
    new Reason(
      UTILITY,
      'Utility issues have delayed work'
    ),
    new Reason(
      WEATHER,
      "The weather wasn't good enough to do work."
    ),
    new Reason(OTHER, ''),
  ];
})
.factory('WORK_ORDER_TIME_REASONS', function() {
  return [
    new Reason(
      INITIAL,
      'The initial time item',
    ),
    new Reason(
      MIS_SCOPE,
      'The original scope was incorrect, so the reno manager had to add time for the revised scope.'
    ),
    new Reason(
      VENDOR_DELAYS,
      'Miscellaneous vendor delays, such as truck issues, equipment delays, poor staffing.'
    ),
    new Reason(
      REWORK,
      "The vendor's work didn't pass EQC and/or didn't reach a HQ score of 100."
    ),
    new Reason(
      WEATHER,
      "The weather wasn't good enough to do work."
    ),
    new Reason(
      UTILITY,
      "Utilities weren't on, so the vendor was unable to work."
    ),
    new Reason(
      PERMIT,
      'City permit delay for trade work.'
    ),
    new Reason(
      FOUNDATION,
      'Foundation needed work.'
    ),
    new Reason(
      EXPERIMENT,
      "There is an experiment that's causing delay, e.g. REIT project that puts reno on pause."
    ),
    new Reason(
      TARGET_CHANGE,
      'COE or LCO changed, pushing out the earliest start date.'
    ),
    new Reason(OTHER, ''),
  ];
})
.factory('vendorTimeReasonDescription', function(VENDOR_TIME_ESTIMATE_REASONS) {
  return function(reason) {
    if (!reason) return undefined;
    let rsn = find(VENDOR_TIME_ESTIMATE_REASONS, { reason });
    if (rsn) {
      return rsn.description;
    } else {
      return undefined;
    }
  };
})
.factory('workOrderTimeReasonDescription', function(WORK_ORDER_TIME_REASONS) {
  return function(reason) {
    if (!reason) return undefined;
    let rsn = find(WORK_ORDER_TIME_REASONS, { reason });
    if (rsn) {
      return rsn.description;
    } else {
      return undefined;
    }
  };
})
.name;




/** WEBPACK FOOTER **
 ** ./javascripts/common/values/work-order-time-estimate-types.js
 **/